// pages/Help/Help.jsx
import React, { useEffect, useRef, useState } from "react";
import HelpAside from "../components/HelpAside";
import checkOn from "../../../assets/image/home/checkOn.png"
import checkOff from "../../../assets/image/home/checkOff.png"
import wizMarket from  "../../../assets/image/home/wizMarketLogo.png"

const API = process.env.REACT_APP_FASTAPI_ADS_URL; // 예: http://localhost:8000

const EMAIL_DOMAINS = ["선택안함", "naver.com", "gmail.com", "nate.com", "daum.net"];
const INQUIRY_TYPES = [
    "제품 일반문의",
    "제품 불편문의",
    "서비스 불편문의",
    "아이디어/제안/칭찬",
    "개인정보 문의",
    "기타 문의",
];

const Help = () => {
    /** 공통 드롭다운 */
    const Dropdown = ({ value, onChange, options = [], placeholder = "선택안함", className = "" }) => {
        const [open, setOpen] = useState(false);
        const ref = useRef(null);

        useEffect(() => {
            const onDoc = (e) => {
                if (!ref.current) return;
                if (!ref.current.contains(e.target)) setOpen(false);
            };
            document.addEventListener("mousedown", onDoc);
            return () => document.removeEventListener("mousedown", onDoc);
        }, []);

        return (
            <div ref={ref} className={`relative ${className}`}>
                <button
                    type="button"
                    className="w-full h-11 px-4 border rounded-lg text-left flex items-center justify-between"
                    onClick={() => setOpen((v) => !v)}
                >
                    <span className={value ? "text-gray-900" : "text-gray-400"}>
                        {value || placeholder}
                    </span>
                    <svg width="16" height="16" viewBox="0 0 24 24" className="opacity-70">
                        <path d="M7 10l5 5 5-5" fill="none" stroke="currentColor" strokeWidth="2" />
                    </svg>
                </button>
                {open && (
                    <div className="absolute z-10 w-full rounded-xl border bg-white shadow-lg py-2 top-12">
                        {options.map((opt) => (
                            <button
                                key={opt}
                                type="button"
                                className={`w-full text-left px-4 py-2 hover:bg-gray-50 ${opt === value ? "text-violet-600 font-medium" : "text-gray-700"}`}
                                onClick={() => {
                                    onChange(opt);
                                    setOpen(false);
                                }}
                            >
                                {opt}
                            </button>
                        ))}
                    </div>
                )}
            </div>
        );
    };

    // 동의서 스크롤/동의
    const scrollRef = useRef(null);
    const [scrolledEnd, setScrolledEnd] = useState(false);
    const [agree, setAgree] = useState(false);

    useEffect(() => {
        const el = scrollRef.current;
        if (!el) return;
        const onScroll = () => {
            if (el.scrollTop + el.clientHeight >= el.scrollHeight - 1) {
                setScrolledEnd(true);
            }
        };
        el.addEventListener("scroll", onScroll);
        return () => el.removeEventListener("scroll", onScroll);
    }, []);

    // 폼 상태 (UI 전용)
    const [name, setName] = useState("");
    const [emailId, setEmailId] = useState("");
    const [emailDomain, setEmailDomain] = useState("");
    const [emailPick, setEmailPick] = useState("선택안함");
    const [phone1, setPhone1] = useState("");
    const [phone2, setPhone2] = useState("");
    const [phone3, setPhone3] = useState("");
    const [inquiryType, setInquiryType] = useState("제품 일반문의");
    const [title, setTitle]  = useState("")
    const [content, setContent] = useState("");
    const [fileNames, setFileNames] = useState(["", "", ""]);
    const [submitting, setSubmitting] = useState(false);

    // 이메일 도메인 선택 로직
    useEffect(() => {
        if (emailPick !== "선택안함") setEmailDomain(emailPick);
    }, [emailPick]);

    const pickFile = (idx) => {
        const input = document.getElementById(`helpFile-${idx}`);
        if (input) input.click();
    };

    const onFileChange = (idx, e) => {
        const f = e.target.files?.[0];
        const name = f ? f.name : "";
        setFileNames((prev) => prev.map((v, i) => (i === idx ? name : v)));
    };

    const deleteFile = (idx, e) => {
        setFileNames((prev) => prev.map((v, i) => (i === idx ? "" : v)));
        const el = document.getElementById(`helpFile-${idx}`);
        if (el) el.value = ""; // 같은 파일 재선택 허용을 위해 초기화
    };

    
    // 연락처 입력 제한(숫자만 + 길이 + 자동 포커스)
    const p1Ref = useRef(null);
    const p2Ref = useRef(null);
    const p3Ref = useRef(null);
    const onlyDigits = (s) => s.replace(/\D/g, "");
    const focusNext = (ref) => {
        ref.current?.focus();
        requestAnimationFrame(() => ref.current?.focus());
        setTimeout(() => ref.current?.focus(), 0);
    };

    const onPhone1 = (e) => {
        setPhone1(onlyDigits(e.target.value).slice(0, 3));
    };
    const onPhone2 = (e) => {
        setPhone2(onlyDigits(e.target.value).slice(0, 4));
    };
    const onPhone3 = (e) => {
        setPhone3(onlyDigits(e.target.value).slice(0, 4));
    };

    useEffect(() => {
        if (phone1.length === 3) {
            focusNext(p2Ref);
        }
    }, [phone1]);

    useEffect(() => {
        if (phone2.length === 4) {
            focusNext(p3Ref);
        }
    }, [phone2]);


    const resetForm = () => {
        setName("");
        setEmailId("");
        setEmailDomain("");
        setEmailPick("선택안함");
        setPhone1("");
        setPhone2("");
        setPhone3("");
        setInquiryType("제품 일반문의");
        setContent("");
        setFileNames(["", "", ""]);
        setAgree(false);
        setScrolledEnd(false);
        for (let i = 0; i < 3; i++) {
            const el = document.getElementById(`helpFile-${i}`);
            if (el) el.value = "";
        }
    };

    const handleSubmit = async () => {
        if (!agree || submitting) return;

        const email = `${(emailId || "").trim()}@${(emailDomain || "").trim()}`;
        if (!name.trim()) {
            window.alert("이름을 입력해 주세요.");
            return;
        }
        if (!emailId.trim() || !emailDomain.trim() || !email.includes("@")) {
            window.alert("이메일을 정확히 입력해 주세요.");
            return;
        }
        if (!content.trim()) {
            window.alert("문의 내용을 입력해 주세요.");
            return;
        }

        const fd = new FormData();
        fd.append("name", name.trim());
        fd.append("email", email);
        const phone = [phone1, phone2, phone3].filter(Boolean).join("-");
        if (phone) fd.append("phone", phone);
        fd.append("category", inquiryType);
        fd.append("title", title)
        fd.append("content", content);

        const f1 = document.getElementById("helpFile-0")?.files?.[0];
        const f2 = document.getElementById("helpFile-1")?.files?.[0];
        const f3 = document.getElementById("helpFile-2")?.files?.[0];
        if (f1) fd.append("file1", f1);
        if (f2) fd.append("file2", f2);
        if (f3) fd.append("file3", f3);

        try {
            setSubmitting(true);
            const res = await fetch(`${API}/help/`, { method: "POST", body: fd });
            const ct = res.headers.get("content-type") || "";
            const isJson = ct.includes("application/json");
            const body = isJson ? await res.json().catch(() => ({})) : await res.text();

            if (!res.ok) {
                if (res.status === 404 || res.status === 405) {
                    // 백엔드에 POST 미구현인 경우도 친절히 안내
                    throw new Error("현재 온라인 접수(등록) 기능이 준비되지 않았습니다.");
                }
                const msg = isJson ? (body?.detail || JSON.stringify(body)) : String(body || res.statusText);
                throw new Error(msg || "등록에 실패했습니다.");
            }

            window.alert("등록되었습니다. 빠르게 답변드리겠습니다.");
            resetForm();
        } catch (e) {
            console.error(e);
            window.alert(`등록 실패: ${e.message}`);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div id="helpPage" className="min-h-screen bg-white overflow-y-auto"
            style={{
                msOverflowStyle: "none",   // IE, Edge
                scrollbarWidth: "none"     // Firefox
            }}>
            <style>{`
            html, body, #helpPage {-ms-overflow-style: none; scrollbar-width: none;}
            html::-webkit-scrollbar,
            body::-webkit-scrollbar,
            #helpPage::-webkit-scrollbar { display: none; }
            .terms-scroll { scrollbar-width: thin; -ms-overflow-style: auto; }
            .terms-scroll::-webkit-scrollbar { width: 8px; }
            `}
            </style>
            <header className="max-w-6xl mx-auto top-0 z-50">
                <div className="h-15 px-5 py-3 flex items-center justify-between">
                    <a href="/" className="flex items-center gap-2 pl-6">
                        <img src={wizMarket} alt="wizMarket" className="h-8 w-auto" />
                        <p style={{fontFamily: "SonsieOne"}}>wiz Market</p>
                    </a>
                    <div className="flex items-center gap-2">
                        <a href="/help"className="px-8 py-2 inline-flex items-center rounded-md bg-black/10 text-lg hover:bg-black/30">
                            고객센터
                        </a>
                        {/* <div className="px-4 py-2 inline-flex items-center text-white rounded-md bg-[#7864F9]/60 text-lg font-medium hover:bg-[#7864F9]">
                            로그인/회원가입
                        </div> */}
                    </div>
                </div>
            </header>
            <div className="max-w-6xl mx-auto px-6 grid grid-cols-12 gap-8 pt-8">
                {/* 좌측 사이드 */}
                <HelpAside activeKey="help" />

                {/* 메인 */}
                <main className="col-span-12 lg:col-span-9 pb-6">
                    <h1 className="text-2xl font-extrabold tracking-tight">1:1 문의</h1>
                    <p className="text-gray-500 pt-2 pb-6">
                        궁금한 사항을 문의해주세요. 최대한 빠른 시일 내에 답변드리겠습니다.
                        <br /> (토, 일 공휴일 문의는 평일 운영시간 순차적으로 답변됩니다.)
                    </p>

                    {/* 개인정보 동의서 */}
                    <section className="rounded-2xl border p-6">
                        <h2 className="text-lg font-bold">개인정보 수집·이용 동의서</h2>
                        <div
                            ref={scrollRef}
                            className="terms-scroll h-56 overflow-y-auto rounded-xl border p-4 text-sm leading-6 text-black pt-3"
                        >
                            <p className="font-medium">개인정보 수집·이용 동의서</p>
                            <p className="pt-2">
                                제이예스 주식회사(이하 “회사”라 합니다)는 고객님의 개인정보를 중요시하며,
                                「정보통신망 이용촉진 및 정보보호 등에 관한 법률」, 「개인정보보호법」 등 관련 법규를 준수하고 있습니다.
                            </p>

                            <p className="pt-4 font-medium">1. 개인정보 수집 및 이용 목적</p>
                            <p>- 고객 문의에 대한 답변 전달</p>

                            <p className="pt-4 font-medium">2. 수집하는 개인정보 항목</p>
                            <p>- 필수항목: 이름, 휴대폰번호, 이메일, 문의 종류, 제목, 문의내용</p>
                            <p>- 선택항목: 첨부파일</p>

                            <p className="pt-4 font-medium">3. 개인정보의 보유 및 이용기간</p>
                            <p>
                                이용자의 개인정보는 수집·이용에 대한 동의를 철회하거나 삭제를 요청할 경우 또는 개인정보의 수집•이용 목적이 달성되면 지체 없이 파기됩니다.
                                다만, 회사는 관계법령의 규정에 의하여 보존할 필요가 있는 경우 해당 법령에서 정한 바에 의하여 개인정보를 보관할 수 있습니다.
                            </p>
                            <p className="pt-2">- 보존 항목: 이름, 휴대폰번호, 이메일</p>
                            <p>- 보존 근거: 소비자의 불만 또는 분쟁처리에 관한 기록(전자상거래 등에서의 소비자보호에 관한 법률)</p>
                            <p>- 보존 기간: 3년</p>

                            <p className="pt-4  font-medium">4. 동의를 거부할 권리 및 동의 거부에 따른 불이익</p>
                            <p>
                                이용자는 본 서버스의 개인정보 수집•이용에 대한 동의를 거부할 권리가 있으나, 
                                필수항목 수집•이용에 대한 동의 거부 시 본 서비스를 이용할 수 없습니다.
                            </p>
                        </div>

                        <div className="pt-4 flex justify-center">
                            <button
                                type="button"
                                disabled={!scrolledEnd}
                                onClick={() => setAgree((v) => !v)}
                                className={`h-12 rounded-full border px-4 flex items-center justify-center gap-2 transition
                                    ${!scrolledEnd
                                        ? "cursor-not-allowed text-gray-400 border-gray-200 bg-white"
                                        : agree
                                            ? "text-violet-600 border-violet-300 bg-white"
                                            : "text-black border-gray-300 bg-white hover:bg-gray-50"}`}
                            >
                                <img src={agree ? checkOn : checkOff} alt="체크 이미지"
                                    className={`transition-opacity ${scrolledEnd ? "opacity-100" : "opacity-0"}`} />
                                개인정보 수집 및 이용에 동의합니다.
                            </button>
                        </div>
                    </section>

                    {/* 문의 작성 폼 */}
                    <section className="rounded-2xl border p-6 mt-8">
                        {/* 이름 */}
                        <div className="grid grid-cols-12 gap-4">
                            <label className="col-span-12 md:col-span-2 flex items-center text-sm font-semibold text-gray-700">
                                <span className="text-red-500 pr-1">*</span> 이름
                            </label>
                            <div className="col-span-12 md:col-span-10">
                                <input
                                    className="w-full h-11 px-4 border rounded-lg"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    placeholder=""
                                />
                            </div>
                        </div>

                        {/* 이메일 */}
                        <div className="grid grid-cols-12 gap-4 pt-4">
                            <label className="col-span-12 md:col-span-2 flex items-center text-sm font-semibold text-gray-700">
                                <span className="text-red-500 pr-1">*</span> 이메일
                            </label>
                            <div className="col-span-12 md:col-span-10 grid grid-cols-12 gap-2">
                                <input
                                    className="col-span-4 h-11 px-4 border rounded-lg"
                                    value={emailId}
                                    onChange={(e) => setEmailId(e.target.value)}
                                />
                                <div className="col-span-1 h-11 flex items-center justify-center select-none">@</div>
                                <input
                                    className="col-span-4 h-11 px-4 border rounded-lg"
                                    value={emailDomain}
                                    onChange={(e) => {
                                        setEmailDomain(e.target.value);
                                        setEmailPick("선택안함");
                                    }}
                                    placeholder=""
                                />
                                <div className="col-span-3">
                                    <Dropdown
                                        value={emailPick}
                                        onChange={setEmailPick}
                                        options={EMAIL_DOMAINS}
                                        placeholder="선택안함"
                                    />
                                </div>
                            </div>
                        </div>

                        {/* 연락처 */}
                        <div className="grid grid-cols-12 gap-4 pt-4">
                            <label className="col-span-12 md:col-span-2 flex items-center text-sm font-semibold text-gray-700">
                                <span className="text-red-500 pr-1">*</span> 연락처
                            </label>
                            <div className="col-span-12 md:col-span-10 grid grid-cols-12 gap-2">
                                <input
                                    className="col-span-3 h-11 px-4 border rounded-lg"
                                    ref={p1Ref}
                                    type="tel"
                                    value={phone1}
                                    onInput={onPhone1}
                                    inputMode="numeric"
                                />
                                <div className="col-span-1 h-11 flex items-center justify-center">-</div>
                                <input
                                    className="col-span-3 h-11 px-4 border rounded-lg"
                                    ref={p2Ref}
                                    type="tel"
                                    value={phone2}
                                    onInput={onPhone2}
                                    inputMode="numeric"
                                />
                                <div className="col-span-1 h-11 flex items-center justify-center">-</div>
                                <input
                                    className="col-span-4 h-11 px-4 border rounded-lg"
                                    ref={p3Ref}
                                    type="tel"
                                    value={phone3}
                                    onInput={onPhone3}
                                    inputMode="numeric"
                                />
                            </div>
                        </div>

                        {/* 문의 종류 */}
                        <div className="grid grid-cols-12 gap-4 pt-4">
                            <label className="col-span-12 md:col-span-2 flex items-center text-sm font-semibold text-gray-700">
                                <span className="text-red-500 pr-1">*</span> 문의 종류
                            </label>
                            <div className="col-span-12 md:col-span-10 md:max-w-md">
                                <Dropdown
                                    value={inquiryType}
                                    onChange={setInquiryType}
                                    options={INQUIRY_TYPES}
                                />
                            </div>
                        </div>

                        <div className="grid grid-cols-12 gap-4 pt-4">
                            <label className="col-span-12 md:col-span-2 flex items-center text-sm font-semibold text-gray-700">
                                <span className="text-red-500 pr-1">*</span> 제목
                            </label>
                            <div className="col-span-12 md:col-span-10">
                                <input
                                    className="w-full h-11 px-4 border rounded-lg"
                                    value={title}
                                    onChange={(e) => setTitle(e.target.value)}
                                    placeholder=""
                                />
                            </div>
                        </div>

                        {/* 내용 */}
                        <div className="grid grid-cols-12 gap-4 pt-4">
                            <label className="col-span-12 md:col-span-2 flex items-start text-sm font-semibold text-gray-700 pt-2">
                                <span className="text-red-500 pr-1">*</span> 내용
                            </label>
                            <div className="col-span-12 md:col-span-10">
                                <textarea
                                    className="w-full h-40 px-4 py-3 border rounded-lg"
                                    value={content}
                                    onChange={(e) => setContent(e.target.value)}
                                    placeholder="민감한 개인정보는 절대 노출하지마세요"
                                />
                            </div>
                        </div>

                        {/* 첨부파일 */}
                        <div className="grid grid-cols-12 gap-4 pt-4">
                            <label className="col-span-12 md:col-span-2 flex items-start text-sm font-semibold text-gray-700 pt-2">
                                첨부파일
                            </label>
                            <div className="col-span-12 md:col-span-10 md:max-w-xl space-y-2">
                                {[0, 1, 2].map((i) => (
                                    <div key={i} className="flex gap-2">
                                        <input
                                            className="flex-1 h-11 px-4 border rounded-lg"
                                            value={fileNames[i]}
                                            readOnly
                                            placeholder=""
                                        />
                                        <input
                                            id={`helpFile-${i}`}
                                            type="file"
                                            accept="image/*"
                                            className="hidden"
                                            onChange={(e) => onFileChange(i, e)}
                                        />
                                        <button
                                            type="button"
                                            className="h-11 px-4 rounded-lg border bg-gray-50 hover:bg-gray-100"
                                            onClick={() => pickFile(i)}
                                        >
                                            찾아보기
                                        </button>
                                        <button
                                            type="button"
                                            className="h-11 px-4 rounded-lg border bg-white hover:bg-red-50 text-red-600 disabled:opacity-40"
                                            onClick={() => deleteFile(i)}
                                            disabled={!fileNames[i]}
                                        >
                                            삭제
                                        </button>
                                    </div>
                                ))}

                                <p className="text-xs text-gray-500 pt-2">
                                    *사진(이미지)만 등록 가능합니다. (최대 10MB 등록 가능)
                                </p>
                            </div>
                        </div>

                        {/* 액션 버튼 */}
                        <div className="flex items-center justify-center gap-3 pt-8">
                            <button
                                type="button"
                                className="h-12 px-6 rounded-full border bg-gray-50 hover:bg-gray-100"
                                onClick={resetForm}
                                disabled={submitting}
                            >
                                작성취소
                            </button>
                            <button
                                type="button"
                                disabled={!agree || submitting}
                                onClick={handleSubmit}
                                className={`h-12 px-8 rounded-full text-white ${agree && !submitting ? "bg-violet-600 hover:bg-violet-700" : "bg-gray-300 cursor-not-allowed"}`}
                            >
                                {submitting ? "등록 중..." : "등록하기"}
                            </button>
                        </div>
                    </section>
                </main>
            </div>
        </div>
    );
};
export default Help;
